export const dcrFormModalStyles = {
	title: {
		display: 'flex',
		flexDirection: 'column',
		gap: 1
	},

	mainHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 1
	},

	textTitle: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
		minWidth: 0,
		fontSize: '1.25rem',
		fontWeight: 700
	},

	titleActions: {
		display: 'flex',
		alignItems: 'flex-end',
		flexDirection: 'row',
		flexWrap: 'nowrap',
		gap: 1
	},

	closeIcon: {
		color: 'text.secondary',
		cursor: 'pointer'
	},

	dcrLink: {
		textTransform: 'none'
	},

	content: {
		position: 'relative',
		display: 'flex',
		flexDirection: 'row',
		gap: 1,
		pb: 2
	},

	steps: {
		display: 'flex',
		flexDirection: 'column',
		flex: 1,
		minWidth: 0,
		gap: 4.5,
		pt: 2
	},

	loadingIndicator: {
		height: 208,
		width: '100%'
	},

	formStep: (visible: boolean) => ({
		display: visible ? 'block' : 'none',
		height: '100%'
	}),

	modal: (isReview: boolean) => ({
		footer: isReview
			? {
					backgroundColor: 'background.paper',
					borderTop: '1px solid var(--mui-palette-divider)',
					px: 2,
					py: 2,
					mt: 0
				}
			: {
					backgroundColor: 'background.paper',
					borderTop: '1px solid var(--mui-palette-divider)',
					padding: 2
				}
	})
};
